import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AccountIcon} from 'shells/icon/svg/account-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {GetForm_form_createRules_account as CreateRulesAccountFragment} from 'nutshell-graphql-types';

import {CreateRulesActionText} from './create-rules-action-text';
import {isCreateRuleEmpty} from './helpers';

type Props = {
    createRules: CreateRulesAccountFragment | null | undefined;
    onClick: () => void;
};

export function CreateRulesCardAccount(props: Props) {
    return (
        // @ts-expect-error
        <TwoLineButtonCard borderColor={colors.plum} onClick={props.onClick}>
            <TwoLine
                icon={AccountIcon}
                iconSize={24}
                iconColor={colors.plum}
                topRow='Create a company'
                bottomRow={getSubtitle(props.createRules)}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
            <CreateRulesActionText createRules={props.createRules} />
        </TwoLineButtonCard>
    );
}

function getSubtitle(createRules?: CreateRulesAccountFragment | null): string | null | undefined {
    if (!createRules || isCreateRuleEmpty(createRules)) {
        return null;
    }

    const tagNames = createRules.tags
        .map((tag) => {
            return tag.name;
        })
        .join(', ');

    return `Tags: ${tagNames}`;
}
